export var MODAL_DATA_HOOKS;
(function (MODAL_DATA_HOOKS) {
    MODAL_DATA_HOOKS["CONTENT"] = "tpa-modal-content";
    MODAL_DATA_HOOKS["OVERLAY"] = "tpa-modal-overlay";
})(MODAL_DATA_HOOKS || (MODAL_DATA_HOOKS = {}));
//# sourceMappingURL=dataHooks.js.map